import getUnitDefenseAtPosition from '../../entity/getUnitDefenseAtPosition'
import type { Entity } from '../../entity/index'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

export default function createDefenseValueGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
) {
  const data = new Uint8Array(gridWidth * gridHeight)
  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      const index = x + (y * gridWidth)
      const positionStack = grid[index]
      if (positionStack) {
        data[index] = getUnitDefenseAtPosition(unit, positionStack)
      }
    }
  }
  return data
}
